import { twApi } from './../api';

import { Company } from './company.model';

/**
 * Api endpoints for company entity
 */
const companyApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyByIds: builder.mutation<Company[], { ids: string[] }>({
      query: ({ ids }) => ({
        url: 'v3/company/get-by-ids',
        body: ids,
        method: 'POST'
      }),
      transformResponse: (response: { data: Company[] }) => response.data
    })
  }),
  overrideExisting: false
});

export const { useGetCompanyByIdsMutation } = companyApi;
